/** 踩点相关api */

import { post } from '@/common/request';

/**
 * @description 踩点记录列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/89777
 */
export function spotSurveyPage(params?: any) {
  return post(
    '/standard/spotSurvey/page',
    { ...params },
    {
      isMock: false,
      mockId: 532,
      mockSuffix: '/api',
      needHint: true,
    }
  );
}

/**
 * @description 简单踩点记录列表（性能好）
 * @yapi https://yapi.lanhanba.com/project/546/interface/api/89795
 */
export function getSpotSurveySimplePage(params?: any) {
  return post(
    '/standard/spotSurvey/simplePage',
    { ...params },
    {
      isMock: false,
      mockId: 532,
      mockSuffix: '/api',
      needHint: true,
    }
  );
}

/**
 * @description 踩点记录详情(新)
 * @yapi https://yapi.lanhanba.com/project/546/interface/api/89657
 */
export function getSpotSurveyDetail(params?: any) {
  return post(
    '/standard/spotSurvey/show',
    { ...params },
    {
      isMock: false,
      mockId: 532,
      mockSuffix: '/api',
      needHint: true,
    }
  );
}

/**
 * @description 导出踩点记录
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/89771
 */
export function spotSurveyExport(params?: any) {
  return post(
    '/standard/spotSurvey/export',
    { ...params },
    {
      isMock: false,
      mockId: 532,
      mockSuffix: '/api',
      needHint: true,
    }
  );
}

/**
 * @description 删除踩点记录
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/89699
 */
export function spotSurveyDelete(params?: any) {
  return post(
    '/standard/spotSurvey/delete',
    { ...params },
    {
      isMock: false,
      mockId: 532,
      mockSuffix: '/api',
      needHint: true,
    }
  );
}
/**
 * @description 踩点关联拓店任务全部分页列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/70020
 */
export function getSpotRelativeTaskPage(params: any) {
  return post(`/standard/task/allPage`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 通过踩点记录 ID 自动创建机会点（不校验必填项，强行生成）
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/98604
 */
export function postChancePointCreateFromSurveyRecord(params: any) {
  return post(`/standard/chancePoint/createFromSurveyRecord`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}
